import { render, staticRenderFns } from "./Refer.vue?vue&type=template&id=12caa3c5&scoped=true&"
import script from "./Refer.vue?vue&type=script&lang=ts&"
export * from "./Refer.vue?vue&type=script&lang=ts&"
import style0 from "./Refer.vue?vue&type=style&index=0&id=12caa3c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12caa3c5",
  null
  
)

export default component.exports